import { useLayoutEffect, useRef, useState, useCallback } from "react";
import { useDebouncedCallback } from "@me8eon/debounce";
import { useLanguage } from "@me8eon/language";
import useSearchStore from "../../../store/searchStore";
import { useJwtToken } from "@me8eon/react_authentication";

export function useAiAssistantPromptArea(listReverse?: boolean) {
    const { fetchSuggestionData, clearQuestionData } = useSearchStore();
    const [language] = useLanguage();
    const esApiKey = useJwtToken();

    const debouncedTriggerSearch = useDebouncedCallback(fetchSuggestionData, 500);

    const [topOffset, setTopOffset] = useState(-46);
    const listRef = useRef<HTMLUListElement>(null);

    useLayoutEffect(() => {
        if (listRef.current && listReverse) {
            const elem = document.getElementsByClassName("list-item-ul")[0];
            if (elem) setTopOffset((elem as HTMLElement).clientHeight);
        } else if (!listReverse) {
            const elem = document.getElementsByClassName("prompt-area-wrapper")[0];
            if (elem) {
                const currentHeight = (elem as HTMLElement).offsetHeight - 1 || 0;
                setTopOffset(-currentHeight);
            }
        }
    });

    const onChangeTrigger = useCallback((txt: string) => {
        if (txt.trim().length > 2) {
            debouncedTriggerSearch(txt, ["suggestions_questions_multilingual"], esApiKey, language);
        } else {
            clearQuestionData()
        }
    }, [debouncedTriggerSearch, language, esApiKey]);

    return {
        esApiKey,
        debouncedTriggerSearch,
        topOffset,
        listRef,
        onChangeTrigger,
    } as const;
}
